import type { RefObject } from 'react';
import type { CtaRefType } from 'util/cta/cta.data';
import { fadeFromTo, fadeTo } from 'util/animation/fade/fade';
import { findTransitionController } from '../../../util/core-transition-component';

interface CircleButtonRefs {
  elementRef: RefObject<CtaRefType | null>;
  labelRef: RefObject<HTMLSpanElement | null>;
  hoverLabelRef?: RefObject<HTMLSpanElement | null>;
  backgroundHoverRef?: RefObject<HTMLDivElement | null>;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { elementRef, labelRef }: CircleButtonRefs,
): void {
  const labelController = findTransitionController(labelRef);

  if (elementRef?.current) {
    timeline.fromTo(
      elementRef.current,
      { scaleX: 0.4 },
      { duration: 0.5, scaleX: 1, ease: 'Expo.easeOut', clearProps: 'scale' },
      0,
    );
    timeline.add(fadeFromTo(elementRef.current as HTMLElement), 0);
  }

  if (labelController) {
    timeline.add(labelController.getTimeline('in') as gsap.core.Timeline, 0);
  }
}

export function setupTransitionOutTimeline(
  timeline: gsap.core.Timeline,
  { elementRef }: CircleButtonRefs,
): void {
  if (elementRef?.current) {
    timeline.add(
      fadeTo(elementRef.current as HTMLElement, {
        duration: 0.4,
        ease: 'Expo.easeOut',
      }),
    );
    timeline.to(elementRef.current, { duration: 0.4, scaleX: 0.4, ease: 'Expo.easeOut' }, 0);
  }
}
